module.exports = "/images/socialtext.png?f5709819ec8c37a1d28250c297a1f131";